{
  "Baslik": "Elementaire Verzekeringen",
  "elementer": {
    "Baslik": "Elementaire Verzekeringen",
    "Yeni Ekle": "Elementaire Verzekering Toevoegen",
    "Ekle": "Toevoegen",
    "Düzenle": "Elementaire Verzekering Bewerken",
    "Genel Bilgiler": "Algemene Informatie",
    "Dosyalar": "Bestanden",
    "Müşteri": "Klant",
    "Sigorta Türü": "Verzekeringstype",
    "Başlangıç Tarihi": "Begindatum",
    "Bitiş Tarihi": "Einddatum",
    "Sigorta Şirketi": "Verzekeringsmaatschappij",
    "Şirket adı seçin veya yazın...": "Selecteer of typ bedrijfsnaam...",
    "Poliçe No": "Polisnummer",
    "Poliçe numarası": "Polisnummer",
    "Tutar": "Bedrag (₺)",
    "UAVT Kodu": "UAVT Code",
    "Adres Kodu": "Adrescode",
    "Araç Marka Model": "Voertuig Merk Model",
    "Örn: 34 ABC 123 - Ford Focus": "bijv. 34 ABC 123 - Ford Focus",
    "Daini Mürtehin": "Daini Murtehin",
    "Banka / Finans kurumu yazın...": "Typ bank / financiële instelling...",
    "Adres": "Adres",
    "Açık Adres Bilgisi": "Volledige Adresinformatie",
    "Gidiş Amacı": "Reisdoel",
    "Örn: Turistik / İş Gezisi": "bijv. Toerisme / Zakenreis",
    "Ülke": "Land",
    "Örn: Almanya, Fransa": "bijv. Duitsland, Frankrijk",
    "Açıklama": "Beschrijving",
    "Ek notlar ve açıklamalar...": "Aanvullende opmerkingen en beschrijvingen...",
    "Takip": "Volgen",
    "Takip Ediliyor": "Volgend",
    "Takip Edilmiyor": "Niet Volgend",
    "Aktif": "Actief",
    "Pasif": "Passief",
    "Kalan Gün": "Resterende Dagen",
    "Gün": "Dagen",
    "Gün Geçti": "Dagen Verstreken",
    "Gün Kaldı": "Dagen Resterend",
    "Bugün Bitiyor": "Verloopt Vandaag",
    "Süresi Doldu": "Verlopen",
    "Kopyasını Oluştur": "Kopie Maken",
    "Dosya Seç": "Bestand Selecteren (Foto / PDF)",
    "Dosya Seç (Çoklu seçebilirsiniz)": "Bestand Selecteren (Meerdere selecties toegestaan)",
    "Yeni Fotoğraf veya PDF Yükle": "Nieuwe Foto of PDF Uploaden",
    "Örn: Poliçe örneği, Kimlik fotokopisi vb.": "bijv. Poliskopie, ID-kopie enz.",
    "Yüklü Dosyalar Listesi": "Lijst met Geüploade Bestanden",
    "Henüz yüklü dosya bulunmuyor": "Nog geen bestanden geüpload.",
    "Açıklama ekleyin...": "Beschrijving toevoegen...",
    "Açıklamayı Kaydet": "Beschrijving Opslaan",
    "Görüntüle": "Bekijken",
    "Poliçe no, şirket, UAVT vb. ara...": "Zoek polisnummer, bedrijf, UAVT enz...",
    "Takip Listesi": "Lijst Elementaire Verzekeringen Volgen",
    "Tümünü Gör": "Alles Bekijken",
    "Takip Alt Başlık": "Gevolgde polissen die zijn verlopen of binnen 15 dagen verlopen",
    "Poliçeyi İncele": "Polis Bekijken",
    "Tür": "Type",
    "Dosya Açıklaması": "Bestandsbeschrijving",
    "Tutar 0'dan büyük olmalıdır": "Bedrag moet groter zijn dan 0",
    "Yükle": "Uploaden",
    "Durum": "Status",
    "İşlem": "Actie",
    "Hepsi": "Alles",
    "Filtrele": "Filteren",
    "Filtreleri Temizle": "Filters Wisken",
    "Data Yenile": "Gegevens Vernieuwen",
    "Excel": "Excel",
    "Kaydet": "Opslaan",
    "Güncelle": "Bijwerken",
    "İptal": "Annuleren",
    "Sil": "Verwijderen",
    "Silme Onayı": "Bevestig Verwijdering",
    "Bu kaydı silmek istediğinize emin misiniz?": "Weet u zeker dat u dit record wilt verwijderen?",
    "Kayıt silindi": "Record verwijderd",
    "İşlem başarısız": "Bewerking mislukt",
    "Veriler yüklenemedi": "Gegevens konden niet worden geladen",
    "Dask": "DASK",
    "Kasko": "Cascoverzekering",
    "Trafik": "WA-Verzekering",
    "Konut": "Woonverzekering",
    "İş Yeri": "Bedrijfsverzekering",
    "Seyahat": "Reisverzekering",
    "Tamamlayıcı Sağlık": "Aanvullende Zorgverzekering",
    "Özel Sağlık": "Particuliere Ziektekostenverzekering"
  }
}
